import type { RefObject } from 'react';
import type { TextTransitionType } from '../../../util/animation/text/text.types';
import { textTransition } from '../../../util/animation/text/text';
import { fadeFromTo, fadeTo } from '../../../util/animation/fade/fade';

interface PrimaryLinkRefs {
  elementRef: RefObject<HTMLElement | null>;
  iconRef?: RefObject<HTMLElement | null>;
  transitionInType?: TextTransitionType;
  transitionOutType?: TextTransitionType;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, transitionInType, iconRef }: PrimaryLinkRefs,
): void {
  if (elementRef?.current) {
    timeline.add(textTransition(elementRef.current as HTMLElement, transitionInType));
  }

  if (iconRef?.current && transitionInType !== 'none') {
    timeline.add(fadeFromTo(iconRef.current), 0.1);
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, transitionOutType, iconRef }: PrimaryLinkRefs,
): void {
  if (elementRef?.current) {
    timeline.add(textTransition(elementRef.current as HTMLElement, transitionOutType));
  }

  if (iconRef?.current && transitionOutType !== 'none') {
    timeline.add(fadeTo(iconRef.current), 0);
  }
}
